import React, { ReactNode } from 'react'
import { SidebarProvider } from '@node-space/ui-components'
import { FilterContextProvider } from 'components/FilterBar/context/FilterProvider'
import { AccountsContextProvider } from 'contexts/accountsContext'
import { DevXProvider } from 'contexts/devXContext'
import { OfflineContextProvider } from 'contexts/offlineContext'
import { PendingAgreementsProvider } from 'contexts/pendingAgreementsContext'
import { ProfileContextProvider } from 'contexts/profileContext'
import { ThemeProvider } from 'contexts/themeContext'
import { TwoFAProvider } from 'contexts/twoFAContext'
import { WalletActionProvider } from 'pages/Wallets/context/WalletSheetProvider'

export type DataProviderType = {
  data: any
  isLoading: boolean
}

export interface AppProvidersProps {
  children: ReactNode
  profile: DataProviderType
  accounts: DataProviderType
  shouldShowUKInfoBanner: boolean
}

export const AppProviders = ({
  children,
  profile,
  accounts,
  shouldShowUKInfoBanner,
}: AppProvidersProps) => {
  return (
    <ThemeProvider>
      <SidebarProvider className="block">
        <OfflineContextProvider>
          <WalletActionProvider>
            <AccountsContextProvider
              accountsData={accounts?.data}
              isLoading={accounts?.isLoading}
              shouldShowUKInfoBanner={shouldShowUKInfoBanner}
            >
              <ProfileContextProvider profile={profile?.data} isLoading={profile?.isLoading}>
                <FilterContextProvider>
                  <TwoFAProvider>
                    <PendingAgreementsProvider>
                      <DevXProvider>{children}</DevXProvider>
                    </PendingAgreementsProvider>
                  </TwoFAProvider>
                </FilterContextProvider>
              </ProfileContextProvider>
            </AccountsContextProvider>
          </WalletActionProvider>
        </OfflineContextProvider>
      </SidebarProvider>
    </ThemeProvider>
  )
}
